export default val => {
  if (val < 10000) {
    return val;
  } else if (val >= 10000 && val < 100000000) {
    return (val / 10000).toFixed(2) + "万";
  } else {
    return (val / 100000000).toFixed(2) + "亿";
  }
};
